Ext.define('SA.LimitCheck', {
    singleton: true,

    async get({resource, forBusinesses = false, params}) {
        var response = await SA.Ajax.request({method: 'check', resource, data: params}),
            values = this.mapResponse(response);

        if (values.length === 0) {
            return this.forNothingToExport();
        }
        else if (forBusinesses) {
            return new SA.BusinessesLimitCheck(values[0]); 
        }

        return new SA.DefaultLimitCheck(values);
    },

    forChart() {
        return new SA.StaticLimitCheck({canExport: true});
    },

    forNothingToExport() {
        return new SA.StaticLimitCheck({canExport: false});
    },

    getForBusinesses(params) {
        return this.get({resource: 'data/locationLimits', forBusinesses: true, params});
    },

    getForCrosstab(params) {
        return this.get({resource: 'data/crosstabLimits', params});
    },

    getForLocations(params) {
        return this.get({resource: 'data/locationLimits', params});
    },

    mapResponse(response) {
        return Object.entries(response).map(([datasetName, values]) => {
            var {proposedUsage: proposedUse} = values,
                addProposedUse = interval => Object.assign(interval, {proposedUse}),
                perExport = addProposedUse(values.instantaneously),
                perWeek = addProposedUse(values.weekly),
                perYear = addProposedUse(values.yearly);

            return {datasetName, proposedUse, perExport, perWeek, perYear};
        });
    }
});